import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet";

import HeroSection from "./HeroSection";

const PrincipleSection = lazy(() => import("./PrincipleSection"));
const IngredientSection = lazy(() => import("./IngredientSection"));
const StrengthSection = lazy(() => import("./StrengthSection"));
const CustomerSection = lazy(() => import("./CustomerSection"));

const OurAdvantages = () => {
  return (
    <>
      <Helmet>
        <title>Innovative Tech Solutions | Company Journey & Milestones</title>
        <meta
          name="description"
          content="With 35+ skilled employees, 15+ products and a commitment to innovation, integrity and impact, we deliver solutions that simplify workflows and drive business efficiency."
        />
        <meta
          name="keywords"
          content="Lentera company story, tech solutions company, business software innovation, B2B SaaS platform, global tech company."
        />
      </Helmet>

      <HeroSection />

      <Suspense fallback={<div className="h-[400px]" />}>
        <PrincipleSection />
        <IngredientSection />
        <StrengthSection />
        <CustomerSection />
      </Suspense>
    </>
  );
};

export default OurAdvantages;
